<template>
    <div class="site-content">
        <div class="declare-gl">
            <div style="width: 947px;float: left;height: 120px;">
                <blockquote class="layui-elem-quote" style="padding: 23px;">
                    <h1 v-if="!HeaderFlag" style="font-size:19px;font-weight: bold;margin-bottom: 7px;">
                        {{this.$storage.get('declareUser').userName}}&nbsp;&nbsp;您好：<p class="declare_now"
                            style="display: inline-block"><span style="color: red">你有一个职业工种-{{workTypeName}}-待提交</span>

                            <a @click="examine1" class="viewzybz"
                                style="font-size: 12px;color:blue;text-decoration:block!important;">&gt;&gt;查看职业标准</a>
                        </p>
                    </h1>
                    <p v-if="HeaderFlag" style="font-size: 16px;line-height: 23px;" id="user_declare_desc">
                        <span style="font-weight: normal;font-size: 15px;">当前板块可认定申报等级为《
                            {{workTypeLevelName}}》
                        </span>
                        是否立即认定？
                        <a @click="ImmediatelyDecided" class="rending-btn"
                            style="font-size: 12px;color:red;font-weight: 600;text-decoration:block!important;"
                            data-id="58">&gt;&gt;立即认定</a>
                    </p>
                </blockquote>
            </div>
            <div style="clear: both;"></div>
            <div class="" style="width: 950px">
                <a href="javascript:;" @click="enterTrain" class="layui-btn layui-btn-lg training-btn" style="height: 120px;
                           line-height: 120px;
                           width: 170px;
                           font-size: 23px;">
                    <i class="layui-icon layui-icon-read"></i>
                    进入培训
                </a>
                <a href="javascript:;" @click="enterexercise" class="layui-btn layui-btn-lg question-btn"
                    style="background-color: #1E9FFF;height: 120px;line-height: 120px;width: 170px;font-size: 23px;">
                    <i class="layui-icon layui-icon-edit"></i>
                    试题练习
                </a>
                <a href="javascript:;" @click="enterExamHomePage" class="layui-btn layui-btn-lg examination-btn"
                    style="background-color: #FF5722;height: 120px;line-height: 120px;width: 170px;font-size: 23px;">
                    <i class="layui-icon layui-icon-survey"></i>
                    技能考试
                </a>
                <a class="layui-btn layui-btn-lg payment-btn fyjn" @click="paymentOfFee" style="background-color: #49af4a;
                                height: 120px;line-height: 120px;width: 170px;font-size: 23px;">
                    <i class="layui-icon layui-icon-cart-simple "></i>
                    费用缴纳
                </a>
                <a class="layui-btn layui-btn-lg workBiaozhun-btn zybz" @click="professionalStandard" style="background-color: #393D49;
                            height: 120px;line-height: 120px;width: 170px;font-size: 23px;color: white">
                    <i class="layui-icon layui-icon-set "></i>
                    职业标准
                </a>
                <ul style="margin-top: 30px;">
                    <li style="height: 38px;line-height: 38px;color: red;font-size: 20px;"><i
                            class="layui-icon layui-icon-tips"></i>模块说明：</li>
                    <li style="height: 38px;line-height: 38px;border-bottom: 1px solid #ccc;padding-left: 20px;">
                        进入培训：进入培训平台进行相关技能的培训学习；</li>
                    <li style="height: 38px;line-height: 38px;border-bottom: 1px solid #ccc;padding-left: 20px;">
                        试题练习：可进行在线试题联系；</li>
                    <li style="height: 38px;line-height: 38px;border-bottom: 1px solid #ccc;padding-left: 20px;">
                        参加考试：参加在线考试；</li>
                    <li style="height: 38px;line-height: 38px;border-bottom: 1px solid #ccc;padding-left: 20px;">
                        费用缴纳：认定审核通过之后进行费用缴纳；</li>
                </ul>
            </div>
        </div>

        <el-dialog title='职业标准' :visible.sync="dialogTableVisible2" style="margin-top: 0vh;height: auto" :center="true">

            <iframe v-if="pdfFlag" :src="src" style="width: 99%;height: 100%;">
            </iframe>
            <img v-if="imgFlag" :src="src" width="100%" height="100%"></img>
            <div v-if="standardDescFlag" v-html="standardDesc"></div>
            <span v-if="flag">该工种暂无职业标准</span>
        </el-dialog>
    </div>

</template>

<script>


    export default {
        name: 'app',
        components: {

        },
        data() {
            return {
                workTypeId: 0,
                workTypeName: '',
                workTypeLevelName: '',
                HeaderFlag: false,
                dialogTableVisible2: false,
                flag: false,
                pdfFlag: false,
                imgFlag: false,
                standardDescFlag: false,
                src: '',
                standardDesc: ''
            }
        },
        destroyed() {

        },
        created() {
            this.laodData();
            this.workTypeLevelName = this.getWorkTypeLevelStateDesc(this.$route.params.workTypeLevelState);
        },
        methods: {
            ImmediatelyDecided() {
                console.log("lalalala======"+this.$route.params.state);
                if (this.$route.params.state === '1') {
                    this.$router.push({ path: '/beginAffirm/' + this.$route.params.workTypeLevelState + "/" + this.$route.params.state });
                } else {
                    this.$router.push({ path: '/beginAffirm1/' + this.$route.params.workTypeLevelState + "/" + this.$route.params.state });
                }

            },
            paymentOfFee() {
                if (this.$route.params.state === '1') {
                    this.$router.push({ path: '/affirmPayTheFees/' + this.$route.params.workTypeLevelState + "/" + this.$route.params.state });

                } else {
                    this.$router.push({ path: '/affirmPayTheFees1/' + this.$route.params.workTypeLevelState + "/" + this.$route.params.state });
                }
                this.$parent.leftBeginAffirm(6);
            },
            enterTrain() {
                this.$router.push({ path: '/personalCenter' });
            },
            professionalStandard() {

                if (this.$route.params.state === '1') {
                    this.$router.push({ path: '/affirmProfessionalStandard/' + this.$route.params.workTypeLevelState });

                } else {
                    this.$router.push({ path: '/affirmProfessionalStandard1/' + this.$route.params.workTypeLevelState });
                }
                this.$parent.leftBeginAffirm(11);
            },
            getWorkTypeLevelStateDesc(level) {
                var workTypeLevelStateDesc = '';
                switch (level) {
                    case 1:
                        workTypeLevelStateDesc = "高级技师";
                        break; //可选
                    case 2:
                        //语句
                        workTypeLevelStateDesc = "技师";
                        break; //可选
                    case 3:
                        //语句
                        workTypeLevelStateDesc = "三级（高级工）";
                        break; //可选
                    case 4:
                        //语句
                        workTypeLevelStateDesc = "四级（中级工）";
                        break; //可选
                    default: //可选
                        //语句
                        workTypeLevelStateDesc = "五级（初级工）";
                }
                return workTypeLevelStateDesc;
            },
            laodData() {
                let parames = new URLSearchParams();
                parames.append('examineStatus', 1);
                parames.append('levelState', this.$route.params.workTypeLevelState);
                parames.append('userId', this.$storage.get("declareUser").id);

                //获取 当前等级下的上传资料 列表
                this.$axios.post(this.serverUrl + '/getDeclareUserOccupation_v1', parames).then(resp => {
                    if (resp.data.code === 2) {

                        if (resp.data.data.length > 0) {

                            this.workTypeName = resp.data.data[0].workTypeAlias;
                            this.workTypeId = resp.data.data[0].workTypeId;

                        } else {
                            this.HeaderFlag = true;
                        }

                    } else {
                        this.HeaderFlag = true;
                    }
                }).catch(err => {

                })

            },
            examine1() {
                let parames = new URLSearchParams();
                parames.append('workTypeId', this.workTypeId);
                parames.append('levelState', this.$route.params.workTypeLevelState);
                //获取 当前等级下的上传资料 列表
                this.$axios.post(this.serverUrl + '/dict/getDictWorkTypeStandard', parames).then(resp => {

                    if (resp.data.code === 1) {
                        let ArrayList = [];
                        this.dialogTableVisible2 = true;
                        if (resp.data.data.length != 0) {

                            if (resp.data.data[0].standardType === 1) {
                                //图片
                                this.pdfFlag = false;
                                this.flag = false;
                                this.imgFlag = true;
                                this.standardDescFlag = false;

                                this.src = resp.data.data[0].standardDesc;

                            } else if (resp.data.data[0].standardType === 2) {
                                //富文本
                                this.pdfFlag = false;
                                this.flag = false;
                                this.imgFlag = false;
                                this.standardDescFlag = true;

                                this.standardDesc = resp.data.data[0].standardDesc;

                            } else if (resp.data.data[0].standardType === 3) {
                                //pdf
                                this.pdfFlag = true;
                                this.flag = false;
                                this.imgFlag = false;
                                this.standardDescFlag = false;

                                this.src = 'https://jnrd.zcyunedu.com/declare' + this.prefiexUrl + resp.data.data[0].standardDesc;

                                console.log(this.src);
                            }

                        } else {
                            this.pdfFlag = false;
                            this.imgFlag = false;
                            this.standardDescFlag = false;
                            this.flag = true;
                        }

                    }

                }).catch(err => {

                })

            },
            enterexercise() {
                let parames = new URLSearchParams();
                parames.append('userId', this.$storage.get('declareUser').id);
                parames.append('practiceState', 2);
                this.$axios.post(this.serverUrl + '/tm/getPower', parames).then(resp => {

                    if (resp.data.code == 1) {
                        this.$router.push({ path: '/exerciseHomePage' });
                    } else {
                        this.$message({
                            showClose: true,
                            message: '暂无练习权限，请联系管理员！',
                            center: true,
                        });
                    }

                }).catch(err => {
                })
            },
            enterExamHomePage() {
                let parames = new URLSearchParams();
                parames.append('examState', 2);
                parames.append('userId', this.$storage.get('declareUser').id);
                //获取 当前等级下的上传资料 列表
                this.$axios.post(this.serverUrl + '/tm/getTrainPower', parames).then(resp => {

                    if (resp.data.code === 1) {

                        let parames = new URLSearchParams();
                        parames.append('userId', this.$storage.get('declareUser').id);

                        this.$axios.post(this.serverUrl + '/ex/examList', parames).then(resp => {
                            console.log(resp.data.data);
                            if (resp.data.data.length > 0) {
                                //跳转开始前置页面
                                this.$router.push({ path: '/examHomePage', params: { setid: 111222 } });

                            } else {
                                this.$message({
                                    message: '暂无考试信息！',
                                    type: 'warning',
                                    center: true
                                });
                            }

                        }).catch(err => {

                        })

                    } else {
                        this.$message({
                            message: '暂考试权限！',
                            type: 'warning',
                            center: true
                        });
                    }

                }).catch(err => {

                })
            }


        }
    }

</script>

<style scoped>
    .layui-btn+.layui-btn {
        margin-left: 10px;
    }

    .layui-btn {
        display: inline-block;
        height: 38px;
        line-height: 38px;
        padding: 0 18px;
        background-color: #009688;
        color: #fff;
        white-space: nowrap;
        text-align: center;
        font-size: 14px;
        border: none;
        border-radius: 2px;
        cursor: pointer;
    }

    .layui-btn-lg {
        height: 44px;
        line-height: 44px;
        padding: 0 25px;
        font-size: 16px;
    }

    .site-tree,
    .site-content {
        display: inline-block;
        *display: inline;
        *zoom: 1;
        vertical-align: top;
        font-size: 14px;
    }

    .layui-elem-quote {
        margin-bottom: 10px;
        padding: 15px;
        line-height: 22px;
        border-left: 5px solid #009688;
        border-radius: 0 2px 2px 0;
        background-color: #f2f2f2;
    }

    .site-content {
        width: 954px;
        min-height: 900px;
        padding: 20px 0 10px 20px;
    }
</style>


// WEBPACK FOOTER //
// src/components/affirm/beginHomePage.vue